const showToastReducer = (state, action) => ({
  ...state,
  activeToast: { ...action.payload.toast },
});

export default showToastReducer;
